<template>
  <div>
    <div class="col-12">
      <p class="title-report">{{ this.$t('reports.evolAddQuestion.title') }}</p>
    </div>
    <div style="display: flex;">
      <div class="col-3">
        <label for="pergunta-adicional">
          {{ this.$t('reports.evolAddQuestion.additionalQuestionlabel') }}
        </label>
        <b-form-select
          id="pergunta-adicional"
          v-model="selected"
          :options="options"
          @change="handleQuestion"
          :disabled="loading"
          class="mb-3"
        >
          <b-form-select-option-group label="Reviews" v-if="reviews">
            <b-form-select-option
              v-for="(review, i) in reviews"
              :key="i"
              :value="{ type: 'REVIEWS', question: review.text, questionType:'reviews', questionId: review.questionId }"
              style="width: 100px;"
              >{{ review.text }}</b-form-select-option
            >
          </b-form-select-option-group>
          <b-form-select-option-group label="Escala 0 a 10" v-if="csats">
            <b-form-select-option
              v-for="(csat, i) in csats"
              :key="i"
              :value="{ type: 'CSAT', question: csat.text, questionType:'csat', questionId: csat.questionId }"
              >{{ csat.text }}</b-form-select-option
            >
          </b-form-select-option-group>
          <b-form-select-option-group label="Likert" v-if="likerts">
            <b-form-select-option
              v-for="(likert, i) in likerts"
              :key="i"
              :value="{ type: 'LIKERT', question: likert.text, questionType:'likert', questionId: likert.questionId }"
              >{{ likert.text }}</b-form-select-option
            >
          </b-form-select-option-group>

          <b-form-select-option-group label="Likert/Emotion" v-if="likertsEmotions">
            <b-form-select-option
              v-for="(likertEmotion, i) in likertsEmotions"
              :key="i"
              :value="{ type: 'LIKERT_EMOTION', question: likertEmotion.text, questionType:'likert/emotion', questionId: likertEmotion.questionId }"
              >{{ likertEmotion.text }}</b-form-select-option
            >
          </b-form-select-option-group>

          <b-form-select-option-group label="Emotions" v-if="emotions">
            <b-form-select-option
              v-for="(emotion, i) in emotions"
              :key="i"
              :value="{ type: 'EMOTION', question: emotion.text, questionType:'emotion', questionId: emotion.questionId }"
              >{{ emotion.text }}</b-form-select-option
            >
          </b-form-select-option-group>

          <b-form-select-option-group label="Like Dislike" v-if="likeDislikes">
            <b-form-select-option
              v-for="(likeDislike, i) in likeDislikes"
              :key="i"
              :value="{ type: 'LIKE_DISLIKE', question: likeDislike.text, questionType:'like/dislike', questionId: likeDislike.questionId }"
              >{{ likeDislike.text }}</b-form-select-option
            >
          </b-form-select-option-group>

          <b-form-select-option-group label="Multiple" v-if="multiples">
            <b-form-select-option
              v-for="(multiple, i) in multiples"
              :key="i"
              :value="{ type: 'MULTIPLE', question: multiple.text, questionType:'multiple', questionId: multiple.questionId }"
              >{{ multiple.text }}</b-form-select-option
            >
          </b-form-select-option-group>

          <b-form-select-option-group label="Ces 1 a 5" v-if="ces">
            <b-form-select-option
              v-for="(ces, i) in ces"
              :key="i"
              :value="{ type: 'CES', question: ces.text, questionType:'ces', questionId: ces.questionId }"
              >{{ ces.text }}</b-form-select-option
            >
          </b-form-select-option-group>
          <b-form-select-option-group label="NPS" v-if="npss">
            <b-form-select-option
              v-for="(nps, i) in npss"
              :key="i"
              :value="{ type: 'NPS', question: nps.text, questionType:'nps', questionId: nps.questionId }"
              >{{ nps.text }}</b-form-select-option
            >
          </b-form-select-option-group>
        </b-form-select>
      </div>

      <div v-if="loadChart" class="col-12 loader">
        <b-spinner
          variant="primary"
          type="grow"
          label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
      <div v-else-if="!selected && !loadChart">
        <div class="text-center mt-5">
          <p>
            <font-awesome-icon
              :icon="['fas', 'project-diagram']"
              style="margin-right: 20px; font-size: 35px;"
            />
          </p>
          <h5>
            {{ this.$t('reports.evolAddQuestion.reportTitle') }}
          </h5>
          <p>
            {{ this.$t('reports.evolAddQuestion.selAddQuestionLabel') }}
          </p>
        </div>
      </div>

      <div v-else-if="selected && !loading && !loadChart" class="col-9 px-3">
        <div v-if="selected.type === 'MULTIPLE'">
          <b-table
            :responsive="true"
            :items="itemsMultiple"
            :fields="fieldsMultiple"
          ></b-table>
        </div>
        <div v-else class="col-12" style="display: flex;">
          <b-form-checkbox
            class="col-10 right-switch"
            v-model="top2BoxSelected"
            name="check-Top2Box"
            switch
            style="white-space: nowrap;"
          >
            Top 2 box score
          </b-form-checkbox>
          <b-form-checkbox
            class="col-2 right-switch"
            v-model="checked"
            name="check-button"
            switch
          >
            Comparar com {{ returnMetric() }}
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div v-if="selected && !loading && !loadChart" class="col-12 px-3">
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  name: 'EvolutionAdditionalQuestions',
  props: ['reportType', 'accumulated'],
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    checked: async function watchSwitchChecked(value) {
      const values = [];

      const metric = this.returnMetric();

      for (let i = 0; i < this.chartData.series.length; i += 1) {
        values.push(this.chartData.series[i].nps);
      }

      if (value) {
        this.chartOptions.yAxis[0] = {
          labels: {
            format: '{value}',
            style: {
              color: 'green',
            },
          },
          title: {
            text: '',
            style: {
              color: 'blue',
            },
          },
        };

        this.chartOptions.series.push({
          name: metric,
          type: 'spline',
          dataLabels: {
            enabled: true,
          },
          data: values,
          color: '#17a2b8',
        });
      } else {
        this.chartOptions.yAxis[0] = {
          labels: {
            format: '{value}',
            style: {
              color: 'green',
            },
          },
          title: {
            text: '',
            style: {
              color: 'blue',
            },
          },
        };

        this.chartOptions.series.pop({
          name: metric,
          dataLabels: {
            enabled: true,
          },
          type: 'spline',
          data: values,
        });
      }
    },
    actionGroupData: async function watchActionGroupData() {
      if (this.selected) {
        await this.getPeriodLabel();
        await this.handleQuestion();
      }
    },
    reportType: async function watchReportType() {
      if (this.selected) {
        await this.getPeriodLabel();
        await this.handleQuestion();
      }
    },

    accumulated: async function watchAccumulated() {
      if (this.selected) {
        if (!this.accumulated) {
          this.accumulatedText = '';
        } else {
          this.accumulatedText = this.$t('reports.accLabel');
        }
        await this.handleQuestion();
      }
    },

    calendarDates: async function watchCalendar() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myActionId: async function watchActionId() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myActionsIds: async function watchActionsIds() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myIh1: async function watchih1() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myHierarchies1: async function watchMyHierarchies1() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myHierarchies2: async function watchMyHierarchies2() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    myIh2: async function watchih2() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    'indicatorData.value': async function watchActionId() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      if (this.selected) {
        await this.handleQuestion();
      }
      await this.getAdditionalQuestions();
    },

    type: async function watchType() {
      if (this.selected) {
        await this.handleQuestion();
      }
    },

    loading: function watchLoading() {
      if (this.loading) {
        this.options.unshift({
          value: null,
          text: `${this.$t('reports.loadingLabel')}...`,
        });
      } else {
        this.options.splice(0, 1);
      }
    },
    top2BoxSelected: function watchTop2Selected() {
      this.handleQuestion();
    },
  },

  data: () => ({
    monthlyText: '',
    accumulatedText: '',
    userAuth: null,
    selected: null,
    reviews: null,
    likerts: null,
    likertsEmotions: null,
    npss: null,
    csats: null,
    ces: null,
    likeDislikes: null,
    multiples: null,
    emotions: null,
    chartOptions: {},
    myData: null,
    chartData: {},
    type: 'column',
    chartMax: null,
    monthly: false,
    // reportType: 'day',
    loading: false,
    loadChart: false,
    options: [],
    itemsMultiple: [],
    fieldsMultiple: [],
    footerMultiple: [],
    itemsMultipleFooter: [],
    checked: false,
    top2BoxSelected: false,
  }),

  methods: {
    returnMetric() {
      if (this.myMetric.indexOf('nps') !== -1) {
        return 'NPS';
      } else if (this.myMetric.indexOf('ces') !== -1) {
        return 'CES';
      } else if (this.myMetric.indexOf('csat') !== -1) {
        return 'CSAT';
      } else if (this.myMetric.indexOf('5-stars') !== -1) {
        return '5-Stars';
      }
      return '';
    },

    async loadTable(data) {
      const headers = data.series.headers;
      const items = data.series.items;
      // const footers = data.series.footers;
      this.fieldsMultiple = [];
      this.footerMultiple = [];

      let i = 0;
      // eslint-disable-next-line
      for (let property in items[0]){
        const prop = property;
        this.fieldsMultiple.push({
          key: prop,
          label: headers[i],
          sortable: false,
          class: i === 0 ? 'w0' : 'w0 text-center',
        });
        // this.footerMultiple.push({
        //   key: prop,
        //   label: footers[i],
        //   class: i === 0 ? 'w0' : 'w0 text-center',
        // });
        i += 1;
      }

      this.itemsMultiple = items;
    },
    async handleQuestion() {
      if (this.selected !== null) {
        this.loading = true;
        this.loadChart = true;

        if (this.checked) {
          this.checked = false;
        }

        let response;

        if (this.reportType) {
          response = await api.get(
            `/reports/additional-question-chart/${this.userAuth.companyId}/${this.selected.type}`,
            {
              headers: { 'x-access-token': this.userAuth.token },
              params: {
                actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
                startDate: this.calendarDates.start,
                endDate: this.calendarDates.end,
                ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
                ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
                // monthly: this.monthly,
                accumulated: this.accumulated,
                metric: this.myMetric,
                groupId: this.actionGroupData._id,
                question: this.selected.question,
                questionId: this.selected.questionId,
                questionType: this.selected.questionType,
                indicator: this.indicatorName,
                indicatorValue: this.indicatorData.value,
                indicatorRange: this.indicatorData.range,
                reportType: this.reportType,
                isTop2: this.top2BoxSelected,
              },
            },
          );
        }
        if (this.selected.type === 'MULTIPLE') {
          await this.loadTable(response.data);
        } else {
          this.chartData = await response.data;
          this.chartMax = await response.data.max;
          this.renderChart();

          this.chartData.series.map((res) => {
            this.chartOptions.series[0].data.push(res.average);

            if (this.checked) {
              // this.chartOptions.series[1].data.push(res.average);
            }
          });
        }

        this.loading = false;
        this.loadChart = false;
      }
    },
    async getAdditionalQuestions() {
      const response = await api.get(
        `/reports/get-additional-questions/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            reportType: this.reportType,
            systemLanguage: this.$i18n.locale,
          },
        },
      );
      this.reviews = response.data.reviews;
      this.csats = response.data.csat;
      this.likerts = response.data.likert;
      this.likertsEmotions = response.data.likertEmotion;
      this.likeDislikes = response.data.likeDislike;
      this.emotions = response.data.emotions;
      this.multiples = response.data.multiples;
      this.ces = response.data.ces;
      this.npss = response.data.nps;

      if (this.reviews.length === 0) {
        this.reviews = null;
      }

      if (this.csats.length === 0) {
        this.csats = null;
      }
      if (this.npss.length === 0) {
        this.npss = null;
      }

      if (this.likerts.length === 0) {
        this.likerts = null;
      }

      if (this.likertsEmotions.length === 0) {
        this.likertsEmotions = null;
      }

      if (this.likeDislikes.length === 0) {
        this.likeDislikes = null;
      }

      if (this.emotions.length === 0) {
        this.emotions = null;
      }

      if (this.multiples.length === 0) {
        this.multiples = null;
      }

      if (this.ces.length === 0) {
        this.ces = null;
      }
    },

    async renderChart() {
      this.chartOptions = {
        title: {
          align: 'left',
          text: `${this.$t('reports.evolAddQuestion.graphTitle')}
            ${this.monthlyText} ${this.accumulatedText}`,
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: this.type,
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: this.chartData.categories,
          visible: true,
          labels: {},
        },
        yAxis: [
          {
            // Primary yAxis
          },
          {
            // Secondary yAxis
            max: this.chartMax,
            min: this.selected.type === 'NPS' ? -100 : 0,
            gridLineWidth: 0,
            labels: {
              enabled: false,
            },
            title: {
              text: '',
            },
            stackLabels: {
              enabled: true,
              fontWeight: 'bold',
            },
          },
        ],
        series: [
          {
            name: this.$t('reports.evolAddQuestion.additionalQuestionlabel'),
            data: [],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            yAxis: 1,
            dataLabels: {
              enabled: true,
              format: '{y:.2f}',
            },
            tooltip: {
              pointFormat: '<span>{series.name}<b> {point.y:.2f}<b/> <br/>',
              shared: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
              format: '{y:.2f}',
            },
            yAxis: 1,
            tooltip: {
              pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
              shared: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
              format: '{y:.2f}',
            },
            yAxis: 1,
            tooltip: {
              pointFormat: '<span>{series.name}<b> {point.y:.2f}<b/> <br/>',
              shared: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },

          accessibility: {
            pointDescriptionFormatter: (point) => {
              function round(x) {
                return Math.round(x * 100) / 100;
              }
              return `${point.index + 1}, ${point.category}, ${
                point.y
              } millions, ${round(point.percentage)}, ${point.series.name}`;
            },
          },
        },
        colors: ['#4ce595'],
      };

      if (
        this.selected.type === 'EMOTION' ||
        this.selected.type === 'LIKE_DISLIKE'
      ) {
        this.chartOptions.plotOptions = {
          column: {
            dataLabels: {
              enabled: true,
              format: '{y:.2f}%',
            },
          },
          line: {
            dataLabels: {
              enabled: true,
              format: '{y:.2f}%',
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
            stacking: 'percent',
            lineColor: '#ffffff',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#ffffff',
            },
            accessibility: {
              pointDescriptionFormatter: (point) => {
                function round(x) {
                  return Math.round(x * 100) / 100;
                }
                return `${point.index + 1}, ${point.category}, ${
                  point.y
                } millions, ${round(point.percentage)}%, ${point.series.name}`;
              },
            },
          },
        };

        this.chartOptions = {
          ...this.chartOptions,
          tooltip: {
            pointFormat: '<span>{series.name}<b> {point.y:.2f}%<b/>',
            shared: true,
          },
        };
      }
    },
    getPeriodLabel() {
      switch (this.reportType) {
        case 'day':
          this.monthlyText = `- ${this.$t('reports.dailyLabel')}`;
          break;
        case 'week':
          this.monthlyText = `- ${this.$t('reports.weeklyLabel')}`;
          break;
        case 'month':
          this.monthlyText = `- ${this.$t('reports.monthlyLabel')}`;
          break;
        case 'quarter':
          this.monthlyText = `- ${this.$t('reports.quarterlyLabel')}`;
          break;
        default:
          break;
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    // this.monthlyText = `- ${this.$t('reports.dailyLabel')}`;
    // this.accumulatedText = this.$t('reports.accLabel');
    this.getPeriodLabel();
    if (!this.accumulated) {
      this.accumulatedText = '';
    } else {
      this.accumulatedText = this.$t('reports.accLabel');
    }
    this.options = [
      {
        value: null,
        text: this.$t('reports.evolAddQuestion.selSelectAddQuestionLabel'),
      },
    ];
  },

  async mounted() {
    this.loading = true;

    EventBus.$on('data-source', (checked) => {
      this.reportType = checked;
      this.monthly = checked === 'month';
    });

    EventBus.$on('accumulated-report', (checked) => {
      this.accumulated = checked;
    });

    EventBus.$on('switch-chart', (checked) => {
      this.type = checked;
    });
    await this.getAdditionalQuestions();
    this.loading = false;
  },

  beforeDestroy() {
    EventBus.$off('switch-chart');
    EventBus.$off('data-source');
    EventBus.$off('accumulated-report');
  },
};
</script>
<style>
.title-report {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 400;
  color: #bdbdbd;
}

.right-switch {
  text-align: right;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.w500 {
  width: 500px;
}
.w150 {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/evolution-additional-questions/index.vue